export const bufferOptions = [
  1, 2, 3, 4, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 75, 100,
];

export const allowedFileExtentions = [
  ".shp",
  ".geojson",
  ".kml",
  ".zip",
  ".kmz",
];
